import React, { Component } from "react";
import * as BABYLON from '@babylonjs/core';
import ParameterErrors from '../errors/ParameterErrors';
import TwoFingerTouch from '../ui_core/TwoFingerTouch';
const { throwNotProvided } = ParameterErrors;
class BabylonCameraZoom {
	constructor(params){
		const {babylonScene, inertiaDecayFactor, inertiaNegligibleThreshold, zoomSpeedFactor, closestCanGetToSurface}=params||{};
		if(!babylonScene)throwNotProvided('babylonScene');
		this._zoomSpeedFactor = zoomSpeedFactor===undefined?15:zoomSpeedFactor;
		this._babylonScene = babylonScene;
		this._closestCanGetToSurface = closestCanGetToSurface===undefined?3:closestCanGetToSurface;
		this._getMaximumDistanceCanMoveForward= this._getMaximumDistanceCanMoveForward.bind(this);
		this._onPointerWheel= this._onPointerWheel.bind(this);
		babylonScene.scene.onPrePointerObservable.add( this._onPointerWheel, BABYLON.PointerEventTypes.POINTERWHEEL, false);
		new TwoFingerTouch({element:babylonScene.canvas, 
		onStart:()=>{
		}, onStartFinger1:()=>{
		}, onStartFinger2:()=>{
		}, onMoveFinger1:()=>{
		}, onMoveFinger2:()=>{
		}, onEndFinger1:()=>{
		}, onEndFinger2:()=>{
		}
		, onEnd:()=>{
		}});
	}
	_onPointerWheel(pointerInfo, eventState) {
		const event = pointerInfo.event;
		var delta = 0;
		if (event.wheelDelta) {
			delta = event.wheelDelta;
		}
		else if (event.detail) {
			delta = -event.detail;
		}
		if (!delta)return;
		const direction = this._babylonScene.camera.getDirection(new BABYLON.Vector3(0,0,delta>0?1:-1));
		const actualDistanceToMove = this._getMaximumDistanceCanMoveForward(direction, this._zoomSpeedFactor);	
		const scaledDirection = direction.scale(actualDistanceToMove);
		this._babylonScene.addInPlace(scaledDirection);
	}
	_getMaximumDistanceCanMoveForward(direction, distanceWouldLikeToMove){
		const origin = this._babylonScene.camera.position;
		const ray = new BABYLON.Ray(origin, direction, 1000);
		const hit = this._babylonScene.scene.pickWithRay(ray);
		if(!hit.hit)return distanceWouldLikeToMove;
		const distanceLeftToMoveForward = hit.distance - this._closestCanGetToSurface;
		if(distanceLeftToMoveForward>distanceWouldLikeToMove)return distanceWouldLikeToMove;
		return distanceLeftToMoveForward*0.7;
	}
}
export default BabylonCameraZoom;